// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class DashboardUserServiceInterface {
  constructor() {
    this.service_id = 'dashboarduserservice-1_6';
  }

  // UpdateDashboardUserRolesAction, Response: UpdateDashboardUserRolesResponse
  // authUserId: String
  // tenancyId: int
  // tenancyRolesToAdd: Set<String>
  // tenancyRolesToRemove: Set<String>
  updateUserRoles(authUserId, tenancyId, tenancyRolesToAdd, tenancyRolesToRemove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateDashboardUserRolesAction', { authUserId: authUserId, tenancyId: tenancyId, tenancyRolesToAdd: tenancyRolesToAdd, tenancyRolesToRemove: tenancyRolesToRemove }, success_callback);
  }

  updateUserAccessGroupRoles(authUserId, tenancyId, accessGroupId, accessGroupRolesToAdd, accessGroupRolesToRemove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateDashboardUserAccessGroupRolesAction', { authUserId: authUserId, tenancyId: tenancyId, accessGroupId: accessGroupId, accessGroupRolesToAdd: accessGroupRolesToAdd, accessGroupRolesToRemove: accessGroupRolesToRemove }, success_callback);
  }

  validateLoginTokenCredentials(token, tenancy_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'LoginTokenCredentialsValidationRequest', { credentials: this.getLoginTokenCredentials(token), tenancyId: tenancy_id }, success_callback);
  }

  getEmailAndPasswordCredentials(email, password, lockedOutUrl) {
    return { "@type": "EmailCredentials", email: email, password: password, tokenLoginURL: lockedOutUrl };
  }

  getEmailPasswordAndMFACredentials(email, password, mfa_code, lockedOutUrl) {
    return { "@type": "EmailCredentials", email: email, password: password, mfaCode: mfa_code, tokenLoginURL: lockedOutUrl };
  }

  getOAuthCredentials(auth_type, auth_token) {
    return { "@type": "AuthCredentials", authorizationType: auth_type, authorizationCode: auth_token };
  }

  getLoginTokenCredentials(login_token) {
    return { "@type": "LoginTokenCredentials", loginToken: login_token };
  }

  getLoginTokenAndMFACredentials(login_token, mfa_code) {
    return { "@type": "LoginTokenCredentials", loginToken: login_token, mfaCode: mfa_code };
  }

  loginAndGetTenancies(credentials, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserLoginAndGetTenanciesRequest", { credentials: credentials }, onComplete);
  }

  loginAndGetTenanciesWithCredentialsAndAppId(credentials, app_id, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserLoginAndGetTenanciesRequest", { credentials: credentials, appId: app_id }, onComplete);
  }

  loginToTenancyByURL(credentials, tenancy_url, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserSignInToTenancyByURLAction", { credentials: credentials, tenancyURL: tenancy_url }, onComplete);
  }

  loginToTenancyByToken(login_token, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserSignInToTenancyByTokenAction", { loginToken: login_token }, onComplete);
  }

  getEnabledAuthenticationTypes(tenancy_url, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserEnabledAuthenticationTypesRequest", { tenancyURL: tenancy_url }, onComplete);
  }

  confirmLoginRequest(login_id, user_id, login_token, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ConfirmLoginRequest', { loginId: login_id, userId: user_id, loginToken: login_token }, success_callback);
  }

  lookupLoginEmail(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'LoginEmailLookupRequest', request, success_callback);
  }

  lookupToken(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'LoginTokenLookupRequest', request, success_callback);
  }

  /**
   * {
   *   invitationId: String,
   *   authorizationType: String,
  *   authorizationCode: String
   * }
   */
  acceptInvitationWithAutorization(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AcceptInvitationAction', request, callback);
  }

  /**
   * {
   *   invitationId: String,
   *   authorizationType: String ("scalaauth")
   * }
   */
  acceptInvitationWithAuthType(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AcceptInvitationWithAuthTypeAction', request, callback);
  }

  /**
   * {
   *   invitationId: String,
   *   firstName: String,
   *   lastName: String,
   *   password: String,
   * }
   */
  acceptInvitationWithNewProfile(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AcceptInvitationWithNewProfileAction', request, callback);
  }

  /**
   * {
   *   invitationId: String
   * }
   */
  acceptInvitationForUser(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AcceptInvitationForUserAction', request, callback);
  }

  /**
   * {
   *   invitationId: String,
   * }
   */
  getInvitationDetails(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserInvitationDetailsRequest', request, callback);
  }

  createAuthLinkToken(request = {}, callback = () => {}) {
    return ws.sendServiceRequest(this.service_id, 'CreateAuthLinkTokenAction', request, callback);
  }

  linkAuthWithToken(request = { token: '', authorizationCode: '', authorizationType: '' }, callback = () => {}) {
    return ws.sendServiceRequest(this.service_id, 'LinkAuthWithTokenAction', request, callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // login_id: int
  subscribeToCompletedLogin(login_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/completedlogin/' + login_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/completedlogin/' + login_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  getAuthenticationTypes(onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserAuthenticationTypesRequest", {}, onComplete);
  }

  getAccessGroupPermissions(access_group_id, onComplete) {
    return ws.sendServiceRequest(this.service_id, "AccessGroupPermissionsRequest", { accessGroupId: access_group_id }, onComplete);
  }

  getAccessGroupsPermissions(access_group_ids, onComplete) {
    return ws.sendServiceRequest(this.service_id, "AccessGroupsPermissionsRequest", { accessGroupIds: access_group_ids }, onComplete);
  }

  getDashboardUserAccessGroups(tenancy_id, dashboard_user_id, types, onComplete) {
    return ws.sendServiceRequest(this.service_id, "DashboardUserAccessGroupsRequest", { tenancyId: tenancy_id, dashboardUserId: dashboard_user_id, types: types }, onComplete);
  }

  dashboardUsersByTenancyRequest(tenancyId, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUsersByTenancyRequest', { tenancyId: tenancyId }, onComplete, timeout);
  }
  /**
   * -------------------
   * HTTP Request: Model
   * -------------------
   * tenancyId: Integer,
   * --- Filter Options ---
   * includeRoles: Optional List<String>,
   * includeDepartments: Optional List<String>,
   * includeLogin: Optional<TimeWindow>, // TimeWindow datatype >> {startDate: Optional<DateTime>, endDate: Optional<DateTime>}. Note! The two possible parameterisation approaches: (i)Extract logged-in users>> {startDate: DateTime, endDate: DateTime} (ii)Extract never logged-in users>> {startDate: null, endDate: null}
   * includeEmails: Optional List<String>,
   * includeDashboardUserIds: Optional List<String>,
   * includeStatuses: Optional<Set<String>>
   * search: Optional<String>,  // Note! Search by full-name or email
   * --- Sorting Options ---
   * sortBy: Optional<DashboardUsersSortBy>, // [DashboardUsersSortBy enums >> {"lastName", "lastLogin"}]. Note! Either lastName or lastLogin
   * sortOrder: Optional<DashboardUsersSortOrder>, // [DashboardUsersSortOrder enums >> {"asc", "desc"}]. Note! Either asc or desc
   * --- Pagination ---
   * offset: Optional<Integer>,
   * limit: Optional<Integer>
   *
   * --------------------
   * HTTP Response: Model
   * --------------------
   * dashboardUsers: List<DashboardUser>,
   * totalCount: Integer,
   * onFilterTotalCount: Integer
   */
  tenancyDashboardUsersRequest(tenancy_id, include_roles, include_departments, include_login, include_emails, include_dashboarduserids, include_statuses, search_text, sort_by, sort_order, offset, limit, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'TenancyDashboardUsersRequest', {
      tenancyId: tenancy_id,
      includeRoles: include_roles,
      includeDepartments: include_departments,
      includeLogin: include_login,
      includeEmails: include_emails,
      includeDashboardUserIds: include_dashboarduserids,
      includeStatuses: include_statuses,
      search: search_text,
      sortBy: sort_by,
      sortOrder: sort_order,
      offset: offset,
      limit: limit
    }, onComplete, timeout);
  }

  /**
   * -------------------
   * HTTP Request: Model
   * -------------------
   * tenancyId: Integer
   * 
   * --------------------
   * HTTP Response: Model
   * --------------------
   * invitedUsers: List<DashboardUserInvitation>
   */
  dashboardInvitesForTenancyRequest(tenancy_id, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'DashboardInvitesForTenancyRequest', { tenancyId: tenancy_id }, onComplete, timeout);
  }
  /**
   * -------------------
   * HTTP Request: Model
   * -------------------
   * invitationIds: List<String>
   * invitationURL: String
   * 
   * --------------------
   * HTTP Response: Model
   * --------------------
   * --- NONE ---
   */
  resendDashboardUserInvitations(invitation_ids, invitation_url, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'ResendDashboardUserInvitationsAction', { invitationIds: invitation_ids, invitationURL: invitation_url }, onComplete, timeout);
  }
  /**
   * -------------------
   * HTTP Request: Model
   * -------------------
   * invitationId: String
   * 
   * --------------------
   * HTTP Response: Model
   * --------------------
   * removedSuccessfully: boolean
   */
  removeDashboardUserInvitation(invitation_id, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'RemoveDashboardUserInvitationAction', { invitationId: invitation_id }, onComplete, timeout);
  }
  /**
   * -------------------
   * HTTP Request: Model
   * -------------------
   * invitationIds: List<String>
   * 
   * --------------------
   * HTTP Response: Model
   * --------------------
   * removedSuccessfully: boolean
   */
  removeDashboardUserInvitations(invitation_ids, onComplete, timeout) {
    return ws.sendServiceRequest(this.service_id, 'RemoveDashboardUserInvitationsAction', { invitationIds: invitation_ids }, onComplete, timeout);
  }
  /**
     * tenancyId: Integer,
     * emails: List<String>,
     * givenRoles: List<String>,
     * department: Optional<String>,
     * fromUserId: String,
     * invitationURL: String,
     * dashboardLink: Optional<String>,
     * userAccess: Set<UserAccess>,
     * inviteTemplateId: Optional<String>,
     * invitationType: Optional<String>,
     */
  inviteDashboardUsers(request, onComplete) {
    return ws.sendServiceRequest(this.service_id, 'InviteDashboardUsersAction', request, onComplete);
  }

  /*
  private final int tenancyId;
  private final List<String> emails;
  private final List<String> givenRoles;
  private final @Nullable String department;
  private final String fromUserId;
  private final String invitationURL;
  private final @Nullable String dashboardLink;
  private final @Nullable Set<UserAccess> userAccess;
  private final @Nullable String inviteTemplateId;
  private final @Nullable String invitationType;
  private final @Nullable Boolean allowSendToExistingUser;
  */
  inviteDashboardUserToAccessGroup(request, onComplete) {
    return ws.sendServiceRequest(this.service_id, 'InviteDashboardUsersAction', request, onComplete);
  }

  removeDashboardUser(authUserId, tenancyId, onComplete) {
    return ws.sendServiceRequest(this.service_id, 'RemoveDashboardUserAction', { tenancyId: tenancyId, authUserId: authUserId }, onComplete);
  }

  getDashboardUserProfileImage(dashboard_user_id, onComplete) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserProfileImageRequest', { dashboardUserId: dashboard_user_id }, onComplete);
  }

  changeDashboardUserPassword(old_password, new_password, onComplete) {
    return ws.sendServiceRequest(this.service_id, 'ChangeDashboardUserPasswordAction', { oldPassword: old_password, newPassword: new_password }, onComplete);
  }

  getOwnProfile(onComplete) {
    return ws.sendServiceRequest(this.service_id, 'OwnProfileRequest', {}, onComplete);
  }

  /**
   * {
   *   loginToken: String,
   *   tenancyId: Integer,
   * }
   */
  requestAcccessForTenancy(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'RequestAccessForTenancyAction', request, callback);
  }

  /**
   * {
   *   invitationId: String,
   *   approved: Boolean
   * }
   */
  approveInvitation(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'InvitationApprovalAction', request, callback);
  }

  /**
   * {
   * }
   */
  generateLoginToken(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'GenerateLoginTokenAction', request, callback);
  }

  /**
   * {
   *   oldPassword: String,
   *   newPassword: String
   * }
   */
  changePassword(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ChangeDashboardUserPasswordAction', request, callback);
  }

  // ChangeDashboardUserPasswordUsingTokenAction, Response: ChangeDashboardUserPasswordUsingTokenResponse
  // userId: String
  // resetPasswordToken: String
  // newPassword: String
  // appId: String
  // regionURL: Optional<String>
  changePasswordUsingToken(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ChangeDashboardUserPasswordUsingTokenAction', request, callback);
  }

  /**
   * {
   *   password: String
   * }
   */
  setupUserPassword(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'SetupUserPasswordAction', request, callback);
  }

  /**
   * {
   *   loginToken: String,
   *   tenancyId: Integer
   * }
   */
  selectLoginTokenTenancy(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'SelectLoginTokenTenancyAction', request, callback);
  }

  /**
   * {
   *   userIds: Set<String>,
   *   tenancyId: Integer,
   *   department: String,
   * }
   */
  setDashboardUserDepartment(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'SetDashboardUserDepartmentAction', request, callback);
  }

  /**
   * {
   *   tenancyId: Integer,
   *   currentName: String,
   *   newName: String,
   * }
   */
  updateDepartmentName(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateDepartmentNameAction', request, callback);
  }

  /**
   * {
   *   tenancyId: Integer,
   *   currentName: String,
   *   newName: String,
   * }
   */
  subscribeToDashboardUserDepartments(request, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "SubscribeToDashboardUserDepartmentsRequest", data: request };
    var unsubscribe_msg = { service: this.service_id, message: "UnsubscribeFromDashboardUserDepartmentsRequest", data: request };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  setupDashboardUserMFA(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'SetupDashboardUserMFAAction', request, callback);
  }

  verifyDashboardUserMFA(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'VerifyDashboardUserMFAAction', request, callback);
  }

  getDashboardUserMFAInfo(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserMFAInfoRequest', request, callback);
  }

  /**
   * {
   *   email: String,
   *   tenancyUrl: Optional<String>,
   *   redirectUrl: Optional<String>,
  *   appId: Optional<String>,
   * }
   */
  resetPasswordForTenancy(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ResetPasswordForTenancyAction', request, callback);
  }

  /**
   * {
   *   token: String,
   *   email: String,
   *   password: String,
   * }
   */
  verifyPasswordAuthWithToken(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'VerifyPasswordAuthWithTokenAction', request, callback);
  }

  /**
   * {
   *   tenancyId: Integer,
   * }
   */
  subscribeToTenancyUsersInfo(request, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "SubscribeToTenancyUsersInfoRequest", data: request };
    var unsubscribe_msg = { service: this.service_id, message: "UnsubscribeFromTenancyUsersInfoRequest", data: request };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  /**
   * {
   *   userIds: Set<String>,
   *   tenancyId: Integer,
   * }
   */
  activateDashboardUsers(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ActivateDashboardUsersAction', request, callback);
  }

  /**
   * {
   *   userIds: Set<String>,
   *   tenancyId: Integer,
   * }
   */
  deactivateDashboardUsers(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'DeactivateDashboardUsersAction', request, callback);
  }

  /** GLOBAL USER ADMIN STUFF START **/

  adminGetUsers(limit, offset, search, tenancy_ids, sort_by, sort_direction) {
    if (!limit) {
      limit = 50;
    }
    if (!offset) {
      offset = 0;
    }
    if (search === '') {
      search = null;
    }
    if (sort_by == undefined) {
      sort_by = 'lastName';
    }
    if (sort_direction == undefined) {
      sort_direction = 'asc';
    }
    return ws.sendServiceRequest(this.service_id, 'AdminGetUsersRequestV2', { limit: limit, offset: offset, search: search, tenancyIds: tenancy_ids, sortBy: sort_by, sortDirection: sort_direction });
  }

  adminGetUser(user_id) {
    return ws.sendServiceRequest(this.service_id, 'AdminGetUsersRequestV2', { limit: 1, offset: 0, dashboardUserIds: [user_id] }).then(response => {
      if (response.users.length == 1) {
        return response.users[0];
      } else {
        throw `User with id ${user_id} not found!`;
      }
    });
  }

  adminUpdateUserPropertiesAction(user_id, property_map, merge) {
    return ws.sendServiceRequest(this.service_id, 'AdminUpdateUserPropertiesActionV2', { userId: user_id, propertyMap: property_map, merge: merge });
  }

  adminUpdateUserEmailsAction(user_id, emails, merge) {
    return ws.sendServiceRequest(this.service_id, 'AdminUpdateUserEmailsActionV2', { userId: user_id, emails: emails, merge: merge });
  }

  adminSendPasswordResetEmailAction(userId, tenancyId) {
    return ws.sendServiceRequest(this.service_id, 'AdminSendPasswordResetEmailActionV2', { userId: userId, tenancyId: tenancyId });
  }

  adminDeleteUserAction(user_id) {
    return ws.sendServiceRequest(this.service_id, 'AdminDeleteUserActionV2', { userId: user_id });
  }

  adminUpdateUserRoles(authUserId, tenancyId, tenancyRolesToAdd, tenancyRolesToRemove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AdminUpdateDashboardUserRolesActionV2', { wrappedAction: { authUserId: authUserId, tenancyId: tenancyId, tenancyRolesToAdd: tenancyRolesToAdd, tenancyRolesToRemove: tenancyRolesToRemove } }, success_callback);
  }

  adminUpdateUserGeneralRoles(authUserId, rolesToAdd, rolesToRemove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AdminUpdateDashboardUserRolesActionV2', { updateGeneralRoles: true, wrappedAction: { authUserId: authUserId, tenancyId: -1, tenancyRolesToAdd: rolesToAdd, tenancyRolesToRemove: rolesToRemove } }, success_callback);
  }
  /** GLOBAL USER ADMIN STUFF END **/
}

export const FilterCombinationStrategy = Object.freeze({
  and: 'and',
  or: 'or'
});

export const dashboardUserService = new DashboardUserServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/dashboarduserservice.js
// module id = 75ta
// module chunks = 1 2 3 4 5 6